import { Model as BaseModel } from 'vue-api-query'
import env from '@/services/env'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Model extends BaseModel {
  baseURL() {
    return env.apiUrl
  }

  request(config) {
    return this.$http.request(config)
  }

  get createdAt() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }
}
